
/**
* 用工中心 用工结算明细
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用工结算单</el-breadcrumb-item>
      <el-breadcrumb-item>提交结算单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-card">
      <p class="page-card-title">提交结算单</p>
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="info-line" :title="infos.merchantName || ''">
            <span class="info-label">商户名称：</span>
            <span class="info-value">{{ infos.merchantName || "--" }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-line" :title="infos.batchName || ''">
            <span class="info-label">结算单名称：</span>
            <span class="info-value">{{ infos.batchName || "--" }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-line" :title="infos.batchNumber || ''">
            <span class="info-label">结算单批次ID：</span>
            <span class="info-value">{{ infos.batchNumber || "--" }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-line" :title="infos.createdAt || ''">
            <span class="info-label">创建时间：</span>
            <span class="info-value">{{ infos.createdAt || "--" }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="校验状态: ">
        <el-select
          size="small"
          v-model="formInline.status"
          placeholder="请选择"
        >
          <el-option
            v-for="(val, index) in status_list"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号:">
        <el-input
          size="small"
          v-model="formInline.idNumber"
          placeholder="请输入证件号"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>
    <div class="export-bar">
      <el-button size="small" type="primary" @click="exportdata"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="detailId" fixed label="结算单ID" min-width="120">
      </el-table-column>
      <el-table-column label="收款信息" min-width="210">
        <template slot-scope="scope">
          <span>
            {{ scope.row.payeeName }}<br />
            {{ scope.row.payeeAccount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="证件信息" min-width="210">
        <template slot-scope="scope">
          <span>
            {{ scope.row.identityDocumentTypeStr }}<br />
            {{ scope.row.identityDocumentNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="statusStr"
        label="结算单状态"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getStatusColor(scope.row.status),
            }"
            >{{ scope.row.statusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="状态描述" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.detailsRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="serviceFee"
        label="服务费（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="preAmount"
        label="税前金额（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="amountReceived"
        label="到账金额（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFee"
        label="管理费（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeMode"
        label="管理费承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.managementFeeMode === 1">企业承担</span>
          <span v-else-if="scope.row.managementFeeMode === 2">个人承担</span>

          <span v-else-if="scope.row.managementFeeMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxMode"
        label="个税承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.individualIncomeTaxMode === 1">企业承担</span>
          <span v-else-if="scope.row.individualIncomeTaxMode === 2"
            >个人承担</span
          >

          <span v-else-if="scope.row.individualIncomeTaxMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxRate"
        label="个税税率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="individualIncomeTax"
        label="个税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="valueAddedTax"
        label="增值税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="additionalTax"
        label="附加税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="收款备注" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.paymentRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="transSequenceIdn"
        label="流水号"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taskName"
        label="任务名称"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="serviceCharge"
        label="计费范围"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.minCharge }}元~{{ scope.row.maxCharge }}元</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="workload"
        label="工作量"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="rewardsPunishments"
        label="奖惩"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="info"
        label="编号信息"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 3">
            <el-button
              size="small"
              type="primary"
              plain
              @click="handlesDetailEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="handlesDetailDelete(scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <div style="background-color: #fff; padding: 15px; margin: 20px auto">
      <el-row :gutter="20">
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span class="info-label">验证成功笔数：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{ infos.verificationSuccessTotalNum }}</span
              >
            </div>
          </div></el-col
        >
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span class="info-label">验证失败笔数：</span
              ><span
                :style="{
                  color: getStatusColor(8),
                }"
                >{{ infos.verificationFailTotalNum }}</span
              >
            </div>
          </div></el-col
        >
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span class="info-label">总服务费：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{
                  infos.totalServiceFee
                    ? infos.totalServiceFee.toFixed(2)
                    : "0.00"
                }}</span
              >
            </div>
          </div></el-col
        >

        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span class="info-label">总管理费(包含补差价)：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{
                  infos.totalManagementFee
                    ? infos.totalManagementFee.toFixed(2)
                    : "0.00"
                }}</span
              >
            </div>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span class="info-label">总个税：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{
                  infos.individualIncomeTax
                    ? infos.individualIncomeTax.toFixed(2)
                    : "0.00"
                }}</span
              >
            </div>
          </div></el-col
        >
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span class="info-label">总增值税：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{
                  infos.valueAddedTax ? infos.valueAddedTax.toFixed(2) : "0.00"
                }}</span
              >
            </div>
          </div></el-col
        >
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span class="info-label">总附加税：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{
                  infos.additionalTax ? infos.additionalTax.toFixed(2) : "0.00"
                }}</span
              >
            </div>
          </div></el-col
        >
      </el-row>
      <div class="summary-divider"></div>
      <div class="flex_right m-bott-15">
        <span class="info-label">应付总额：</span
        ><span class="pay_num">{{
          infos.totalPay ? infos.totalPay.toFixed(2) : "0.00"
        }}</span>
      </div>
      <div class="flex_right">
        <span class="agree-text">
          <el-checkbox v-model="checked">同意签署</el-checkbox
          ><span class="blue_link" @click="handleshowconfirm"
            >《任务确认单》</span
          >
        </span>
        <el-button size="small" type="primary" @click="submitEvent"
          >提交</el-button
        >
      </div>
    </div>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="540px"
      custom-class="submit-auth-dialog"
      @click="closeDialog"
    >
      <div class="submit-auth-summary">
        <div>
          <div class="submit-auth-k">应付总额</div>
          <div class="submit-auth-amount">
            {{ infos.totalPay ? infos.totalPay.toFixed(2) : "0.00" }}
          </div>
        </div>
        <div class="submit-auth-meta">
          <div class="submit-auth-k">结算批次</div>
          <div
            class="submit-auth-batch"
            :title="infos.batchNumber || $route.query.id"
          >
            {{ infos.batchNumber || $route.query.id }}
          </div>
        </div>
      </div>
      <el-form
        class="submit-auth-form"
        size="small"
        label-position="left"
        label-width="72px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="账号" prop="username">
          <el-input
            type="text"
            name="username"
            disabled
            v-model="editForm.username"
            auto-complete="off"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            name="password"
            v-model="editForm.password"
            auto-complete="new-password"
            placeholder="请输入支付密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            type="text"
            name="mobile"
            disabled
            v-model="mobileMask"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode">
          <div class="sms-row">
            <el-input
              type="text"
              name="smsCode"
              v-model="editForm.smsCode"
              auto-complete="off"
              maxlength="6"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              class="sms-btn"
              size="small"
              plain
              :disabled="smsCountdown > 0"
              :loading="smsSending"
              @click="sendSettlementSms"
              >{{
                smsCountdown > 0 ? smsCountdown + "s后获取" : "获取验证码"
              }}</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div class="submit-auth-actions">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog
      :title="editDetailTitle"
      :visible.sync="editDetailVisible"
      width="750px"
      @close="closeDialog"
    >
      <el-form
        label-position="left"
        label-width="100px"
        :model="editDetailForm"
        :rules="rules"
        ref="editDetailForm"
      >
        <!-- 姓名和证件类型 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名：" prop="payeeName">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.payeeName"
                auto-complete="off"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="mobile">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.mobile"
                auto-complete="off"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证件类型：" prop="identityDocumentType">
              <el-select
                style="width: 220px"
                size="small"
                v-model="editDetailForm.identityDocumentType"
                placeholder="请选择"
              >
                <el-option
                  v-for="(val, index) in identityDocumentTypeList"
                  :label="val.label"
                  :value="val.value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号：" prop="identityDocumentNumber">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.identityDocumentNumber"
                auto-complete="off"
                placeholder="请输入证件号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收款渠道： " prop="paymentChannel">
              <el-select
                style="width: 220px"
                size="small"
                v-model="editDetailForm.paymentChannel"
                placeholder="请选择"
              >
                <el-option
                  v-for="(val, index) in distributionChannelList"
                  :label="val.label"
                  :value="val.value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款账号：" prop="payeeAccount">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.payeeAccount"
                auto-complete="off"
                placeholder="请输入收款账号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="服务费：" prop="serviceFee">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.serviceFee"
                auto-complete="off"
                placeholder="请输入服务费"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注：" prop="">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.paymentRemark"
                auto-complete="off"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditDetailDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitEditDetailForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  putSettlementStatus,
  settlementsAuth,
  settlementsAuthSms,
  checkAggregationResult,
  checksettlementsList,
  deleteSettlementDetail,
  updateSettlementDetail,
  getSettlementDetailsByBatchNumber,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import axios from "axios";
import { Message, MessageBox } from "element-ui";

export default {
  data() {
    return {
      checked: true,
      merchantName_list: [
        {
          label: JSON.parse(localStorage.getItem("user_info")).name,
          value: JSON.parse(localStorage.getItem("user_info")).name,
        },
      ],
      distributionChannelList: [
        {
          label: "银行卡",
          value: 1,
        },
      ],
      identityDocumentTypeList: [
        {
          label: "身份证",
          value: 1,
        },
        {
          label: "护照",
          value: 2,
        },
        {
          label: "台湾通行证(台胞证)",
          value: 3,
        },
        {
          label: "港澳通行证(回乡证)",
          value: 4,
        },
      ],
      status_list: [
        {
          label: "校验中",
          value: 1,
        },
        {
          label: "初验成功",
          value: 2,
        },
        {
          label: "验证失败",
          value: 3,
        },
        {
          label: "已取消",
          value: 4,
        },
        {
          label: "待结算",
          value: 5,
        },
        {
          label: "结算中",
          value: 6,
        },
        {
          label: "结算成功",
          value: 7,
        },
        {
          label: "结算失败",
          value: 8,
        },
        {
          label: "已退款",
          value: 9,
        },
        {
          label: "已退票",
          value: 10,
        },
        {
          label: "银行挂账",
          value: 11,
        },
      ],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "确认提交",
      editForm: {
        username: JSON.parse(localStorage.getItem("user_info")).username,
        password: "",
        smsCode: "",
      },
      smsSending: false,
      smsCountdown: 0,
      smsTimer: null,
      // 确认提交弹窗中展示的登录账号手机号掩码文本
      mobileMask: "",

      editDetailTitle: "编辑结算明细",
      editDetailVisible: false,
      editDetailForm: {
        detailId: "",
        payeeName: "",
        mobile: "",
        identityDocumentType: "",
        identityDocumentNumber: "",
        paymentChannel: "",
        payeeAccount: "",
        serviceFee: "",
        paymentRemark: "",
      },
      // rules表单验证
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入支付密码", trigger: "blur" }],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        payeeName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityDocumentType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        identityDocumentNumber: [
          {
            required: true,
            message: "请输入证件号",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur",
          },
        ],
        paymentChannel: [
          { required: true, message: "请选择收款渠道", trigger: "change" },
        ],
        payeeAccount: [
          { required: true, message: "请输入收款账号", trigger: "blur" },
          {
            pattern: /^\d+$/,
            message: "收款账号必须是数字",
            trigger: "blur",
          },
        ],
        serviceFee: [
          { required: true, message: "请输入服务费", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入服务费"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        paymentRemark: [
          { required: true, message: "请输入备注", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        status: "",
        idNumber: "",
      },
      infos: {},
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    checkAggregationResult(this.$route.query.id)
      .then((res) => {
        this.loading = false;
        if (res.msg != "success") {
          this.$message({
            type: "error",
            message: res.msg,
          });
        } else {
          this.infos = res.data;
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  },
  beforeDestroy() {
    this.clearSmsTimer();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStatusColor(status) {
      // {
      //     label: "校验中",
      //     value: 1,
      //   },
      //   {
      //     label: "初验成功",
      //     value: 2,
      //   },
      //   {
      //     label: "验证失败",
      //     value: 3,
      //   },
      //   {
      //     label: "已取消",
      //     value: 4,
      //   },
      //   {
      //     label: "待结算",
      //     value: 5,
      //   },
      //   {
      //     label: "结算中",
      //     value: 6,
      //   },
      //   {
      //     label: "结算成功",
      //     value: 7,
      //   },
      //   {
      //     label: "结算失败",
      //     value: 8,
      //   },
      //   {
      //     label: "已退款",
      //     value: 9,
      //   },
      //   {
      //     label: "已退票",
      //     value: 10,
      //   },
      //   {
      //     label: "银行挂账",
      //     value: 11,
      //   },
      // 根据状态值返回对应的颜色
      switch (status) {
        case 1:
        case 5:
        case 6:
          return "#409EFF"; // 蓝色
        case 2:
        case 7:
          return "#67C23A"; // 绿色
        case 4:
          return "#909399"; // 灰色
        case 3:
        case 8:
        case 9:
        case 10:
        case 11:
          return "#F56C6C"; // 红色

        default:
          return "#303133"; // 默认黑色
      }
    },
    handlesDetailEdit(row) {
      this.editDetailVisible = true;
      this.editDetailForm = {
        detailId: row.detailId,
        payeeName: row.payeeName,
        mobile: row.mobile,
        identityDocumentType: row.identityDocumentType,
        identityDocumentNumber: row.identityDocumentNumber,
        paymentChannel: row.paymentChannel,
        payeeAccount: row.payeeAccount,
        serviceFee: row.serviceFee,
        paymentRemark: row.paymentRemark,
      };
    },
    handlesDetailDelete(row) {
      MessageBox.confirm(`此操作将永久删除结算单数据，是否继续?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSettlementDetail(row.detailId).then((res) => {
            if (res.msg == "success") {
              this.formInline.batchNumber = this.$route.query.id;
              this.getdata(this.formInline);
              checkAggregationResult(this.$route.query.id)
                .then((res) => {
                  this.loading = false;
                  if (res.msg != "success") {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  } else {
                    this.infos = res.data;
                  }
                })
                .catch((err) => {
                  this.loading = false;
                });
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    // 从登录态缓存读取手机号并生成掩码文本，前3位后4位保留，中间以星号遮盖；未绑定时展示兜底文案
    buildMobileMask() {
      let mobile = "";
      try {
        const userInfo = JSON.parse(localStorage.getItem("user_info"));
        mobile = userInfo && userInfo.mobile ? String(userInfo.mobile) : "";
      } catch (e) {
        mobile = "";
      }
      if (mobile.length >= 8) {
        this.mobileMask = mobile.slice(0, 3) + "****" + mobile.slice(-4);
      } else {
        this.mobileMask = "未绑定手机号";
      }
    },
    submitEvent() {
      if (!this.checked) {
        this.$message({
          type: "error",
          message: "请先同意签署任务确认单",
        });
        return;
      }

      const balance = this.infos.balance ? this.infos.balance : 0;
      const totalPay = this.infos.totalPay ? this.infos.totalPay : 0;
      const frozenBalance = this.infos.frozenBalance
        ? this.infos.frozenBalance
        : 0;
      if (totalPay == 0) {
        this.$message({
          type: "error",
          message: "总支付金额为0，请确认后在提交",
        });
        return;
      }

      if (totalPay > balance) {
        this.$message({
          type: "error",
          message: "可用余额不足，请充值后在提交",
        });
        return;
      }

      if (frozenBalance > 0 && totalPay > balance - frozenBalance) {
        this.$message({
          type: "error",
          message: "可用余额不足您有预开被冻结金额，请充值后在提交",
        });
        return;
      }

      this.buildMobileMask();
      this.editFormVisible = true;
    },
    handleshowconfirm() {
      checksettlementsList(this.$route.query.id)
        .then((res) => {
          if (res.msg == "success") {
            // window.open(res.data.downloadUrl,'newWindow')
            axios
              .get(res.data.downloadUrl, { responseType: "blob" })
              .then((data) => {
                let responseData = data.data;
                let blob = new Blob([responseData], {
                  type: "application/pdf;charset=utf-8",
                });
                const href = URL.createObjectURL(blob);
                window.open(href, "newWindow");
              });
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        status: "",
        idNumber: "",
      };
      this.getdata(this.formInline);
    },
    exportdata() {
      if (!this.$route.query.id) {
        this.$message.error("参数错误，批次号为空");
        return;
      }

      // 默认导出1000
      const params = {
        page: 1,
        pageSize: 1000,
        isExport: 1,
        status: this.formInline.status,
        idNumber: this.formInline.idNumber,
      };

      getSettlementDetailsByBatchNumber(this.$route.query.id, params).then(
        (res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        }
      );
    },
    // 获取公司列表
    getdata(parameter) {
      if (!this.$route.query.id) {
        this.$message.error("参数错误，批次号为空");
        return;
      }
      this.loading = true;
      getSettlementDetailsByBatchNumber(this.$route.query.id, parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {},
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (!valid) {
          return false;
        }
        const username = (this.editForm.username || "").trim();
        const password = this.editForm.password || "";
        const smsCode = (this.editForm.smsCode || "").trim();
        const batchNumber = String(
          this.infos.batchNumber || this.$route.query.id || ""
        ).trim();
        if (!batchNumber) {
          this.$message({
            type: "error",
            message: "批次号不能为空",
          });
          return;
        }
        this.loading = true;
        settlementsAuth({
          username,
          password,
          smsCode,
          batchNumber,
        })
          .then((res) => {
            if (res.msg == "success") {
              putSettlementStatus(batchNumber, { status: 2 })
                .then((res) => {
                  this.loading = false;
                  if (res.msg == "success") {
                    this.$message({
                      type: "success",
                      message: "操作成功",
                    });
                    this.editFormVisible = false;
                    this.$router.push({ path: "/task/employmentStatement" });
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            } else {
              this.loading = false;
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    submitEditDetailForm() {
      this.loading = true;
      this.$refs.editDetailForm.validate((valid) => {
        if (valid) {
          updateSettlementDetail(this.editDetailForm).then((res) => {
            this.loading = false;
            if (res.msg == "success") {
              this.editDetailVisible = false;
              this.formInline.batchNumber = this.$route.query.id;
              this.getdata(this.formInline);
              checkAggregationResult(this.$route.query.id)
                .then((res) => {
                  this.loading = false;
                  if (res.msg != "success") {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  } else {
                    this.infos = res.data;
                  }
                })
                .catch((err) => {
                  this.loading = false;
                });
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //  deptDelete(row.deptId)
          //    .then(res => {
          //      if (res.success) {
          //        this.$message({
          //          type: 'success',
          //          message: '公司已删除!'
          //        })
          //        this.getdata(this.formInline)
          //      } else {
          //        this.$message({
          //          type: 'info',
          //          message: res.msg
          //        })
          //      }
          //    })
          //    .catch(err => {
          //      this.loading = false
          //      this.$message.error('公司删除失败，请稍后再试！')
          //    })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    clearSmsTimer() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
    },
    sendSettlementSms() {
      if (this.smsCountdown > 0 || this.smsSending) {
        return;
      }
      const batchNumber = String(
        this.infos.batchNumber || this.$route.query.id || ""
      ).trim();
      if (!batchNumber) {
        this.$message({
          type: "error",
          message: "批次号不能为空",
        });
        return;
      }
      this.smsSending = true;
      settlementsAuthSms({
        batchNumber,
      })
        .then((res) => {
          this.smsSending = false;
          if (res.msg == "success") {
            this.$message({
              type: "success",
              message: "验证码已发送",
            });
            this.smsCountdown = 60;
            this.clearSmsTimer();
            this.smsTimer = setInterval(() => {
              if (this.smsCountdown <= 1) {
                this.smsCountdown = 0;
                this.clearSmsTimer();
                return;
              }
              this.smsCountdown -= 1;
            }, 1000);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch(() => {
          this.smsSending = false;
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
    closeEditDetailDialog() {
      this.editDetailVisible = false;
    },
  },
};
</script>

<style scoped>
.page-card {
  background-color: #fff;
  padding: 15px 15px 6px;
  margin: 20px auto;
}
.page-card-title {
  line-height: 44px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 16px;
  margin: 0 0 16px;
  color: #303133;
}
.info-line {
  margin-bottom: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.info-label {
  color: #909399;
}
.info-value {
  color: #303133;
}
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.export-bar {
  margin-bottom: 10px;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.m-bott-15 {
  margin-bottom: 15px;
}
.summary-divider {
  height: 1px;
  margin: 4px 0 16px;
  background: #ebeef5;
}
.flex_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}
.agree-text {
  display: inline-flex;
  align-items: center;
}
.pay_num {
  color: #ff943e;
  font-weight: 700;
  font-size: 20px;
}
.blue_link {
  cursor: pointer;
  color: #409eff;
}
.submit-auth-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  margin-bottom: 18px;
  background: #f7f8fa;
  border-radius: 6px;
}
.submit-auth-k {
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1;
  color: #909399;
}
.submit-auth-amount {
  color: #ff943e;
  font-weight: 700;
  font-size: 22px;
  line-height: 1;
}
.submit-auth-meta {
  max-width: 58%;
  min-width: 0;
  text-align: right;
}
.submit-auth-batch {
  overflow: hidden;
  font-size: 13px;
  line-height: 1.4;
  color: #303133;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.submit-auth-form >>> .el-form-item__label,
.submit-auth-form >>> .el-form-item__content {
  line-height: 32px;
}
.submit-auth-form .el-form-item {
  margin-bottom: 16px !important;
}
.submit-auth-form .el-form-item:last-child {
  margin-bottom: 0 !important;
}
.submit-auth-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
}
.sms-row {
  display: flex;
  align-items: center;
}
.sms-row .el-input {
  flex: 1;
  min-width: 0;
}
.sms-btn {
  flex: 0 0 108px;
  height: 32px;
  margin-left: 8px;
  padding: 0 8px;
}
</style>
<style>
.submit-auth-dialog .el-dialog__header {
  padding: 18px 20px 10px;
}
.submit-auth-dialog .el-dialog__body {
  padding: 10px 20px 20px;
}
</style>





// WEBPACK FOOTER //
// src/views/task/employmentStatementSubmit.vue